import script from "./Recommend.vue?vue&type=script&setup=true&lang=js"
export * from "./Recommend.vue?vue&type=script&setup=true&lang=js"

import "./Recommend.vue?vue&type=style&index=0&id=a8e58786&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8e58786"]])

export default __exports__